export default "__VITE_ASSET__BlfxAeSu__"